import DoubtsIcon from 'src/components/Icons/DoubtsIcon'
import SmallArrowRight from 'src/components/Icons/SmallArrowRight'
import { useEffect, useState } from 'react'

import ArrowLeftClub from '../../Icons/ArrowLeftClub'
import FaqClub from '../FaqClub/FaqClub'
import '../clubeStyles.scss'

type DoubtsProps = {
  title: string
  items: Array<{
    active: boolean
    question: string
    response: string
  }>
}

interface DoubtsModalClubProps {
  doubtsArr?: DoubtsProps
  renderFaqSchema?: boolean
}

const DoubtsModalClub = ({
  doubtsArr,
  renderFaqSchema = true,
}: DoubtsModalClubProps) => {
  const [selectedTiers, setSelectedTiers] = useState<boolean>(false)

  useEffect(() => {
    document.body.style.overflow = selectedTiers ? 'hidden' : ''
  }, [selectedTiers])

  return (
    <div className="block font-inter mt-6 mb-[82px] md:m-0">
      <button
        onClick={() => setSelectedTiers(true)}
        className="flex gap-4 mx-auto text-left w-[343px] p-4 text-base leading-6 font-semibold border border-[#D9DDE1]"
      >
        <DoubtsIcon />
        {doubtsArr?.title}
        <SmallArrowRight className="ml-auto mt-[5px]" />
      </button>

      {/* Overlay */}
      {selectedTiers && (
        <button
          className="fixed inset-0 bg-black/40 z-40 modal-overlay"
          onClick={() => setSelectedTiers(false)}
        />
      )}

      {/* Modal */}
      <div className={`modal-container ${selectedTiers ? 'open' : ''}`}>
        <div className="flex px-4 py-3">
          <button onClick={() => setSelectedTiers(false)}>
            <ArrowLeftClub />
          </button>
          <p className="block mx-auto text-base font-medium ">
            {doubtsArr?.title}
          </p>
        </div>

        <div className="p-4">
          <FaqClub renderFaqSchema={renderFaqSchema} doubtsArr={doubtsArr} />
        </div>
      </div>
    </div>
  )
}

export default DoubtsModalClub
